import { useState } from "react"
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
} from "@mui/material"
import { Save as SaveIcon, Cancel as CancelIcon } from "@mui/icons-material"
import { Controller, useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { useApiMutation } from "../../hooks/useApi"
// import { error } from "console"

function AddClientPage() {
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState({ type: "", text: "" })
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control
  } = useForm()

  const createClientMutation = useApiMutation("/clients/register", "POST", {
    onSuccess: () => {
      setMessage({ type: "success", text: "Client created successfully!" })
      reset()
      setTimeout(() => navigate("/clients"), 2000)
    },
    onError: (error) => {
      setMessage({ type: "error", text: error.response?.data?.message || "Failed to create client" })
    },
  })

  const onSubmit = async (data) => {
    setLoading(true)
    setMessage({ type: "", text: "" })
    data.panNumber = data.panNumber.trim()
    createClientMutation.mutate(data)
    setLoading(false)
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Add New Client
      </Typography>

      {message.text && (
        <Alert severity={message.type} sx={{ mb: 3 }}>
          {message.text}
        </Alert>
      )}

      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                required
                fullWidth
                label="Full Name"
                {...register("name", { required: "Name is required" })}
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                fullWidth
                label="Phone number"
                type="phoneNumber"
                {...register("phoneNumber", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Invalid phone number address",
                  },
                })}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber?.message}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="panNumber"
                control={control}
                rules={{
                  required: "PAN is required",
                  pattern: {
                    value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                    message: "Invalid PAN format (ABCDE1234F)",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="PAN Number"
                    error={!!errors.panNumber}
                    helperText={errors.panNumber?.message}
                    onChange={(e) => {
                      const upper = e.target.value.toUpperCase()
                      field.onChange(upper)   // <-- IMPORTANT: this triggers RHF validation
                    }}
                    sx={{ "& input": { textTransform: "uppercase" } }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField required fullWidth label="Address" {...register("address",{required: "Address is required",})} />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Constitution</InputLabel>
                <Select label="Constitution" {...register("constitution")} defaultValue="Individual">
                  <MenuItem value="Individual">Individual</MenuItem>
                  <MenuItem value="Firm">Firm</MenuItem>
                  <MenuItem value="Company">Company</MenuItem>
                  <MenuItem value="LLP">LLP</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
              required
              label="Trade Name"
              {...register("tradeName",{
                required:"Trade name is required",
              })}
              error={!!errors.tradeName}
              helperText={errors.tradeName?.message}
              >
              </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
              label="GSTIN Number"
              {...register("gstinNumber",{
                pattern:{
                  value:/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                  message:"Invalid GSTIN pattern"
                }
              })}
              onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase()
              }}
              error={!!errors.gstinNumber}
              helperText={errors?.gstinNumber?.message}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Client"}
            </Button>
            <Button variant="outlined" startIcon={<CancelIcon />} onClick={() => navigate("/clients")}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default AddClientPage